/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The value origin:
 *   * ACQUIRED: acquired (OPCUA...)
 *   * ADDED: injected
 */
export enum ValueOrigin {
  ACQUIRED = 'ACQUIRED',
  ADDED = 'ADDED'
}
